module.exports = __webpack_public_path__ + "static/img/11.962b21d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/11.png
// module id = moBe
// module chunks = 0